import { props } from '../hard-token-integration-properties';
import { maxTokenCount } from '../max-token-count';

export class Controller {

    /** @ngInject */
    constructor($scope,$rootScope) {
        this.$scope = $scope;
        this.$rootScope=$rootScope;
    }

    $onInit() {
        this.$scope.$watch('form.$valid', (valid) => {
            this.valid = valid;
            this.changed();
        });
    }

    get props() {
        return props[this.type][this.otpType];
    }
    
    getPattern(prop){
		if(prop.name=='registrationEmail') {
			return this.$rootScope.emailPattern;
		} else{
			return prop.pattern;
		}
	}

    addToken() {
		var newToken={};
		/*
		if(this.otpType='U2F'){
			var serialAuto="FIDO Token "+(this.tokens.length+1);
			newToken={serial: serialAuto}
		}*/
        this.tokens = [...this.tokens, newToken];
        this.changed();
    }

    addTokenDisabled() {
        return this.tokens.length >= maxTokenCount;
    }

    remove(token) {
        this.tokens = this.tokens.filter((t) => t !== token);
        this.changed();
    }

    changed() {
        this.onChange({tokens: this.tokens, valid: this.valid});
    }

    getErrorMessage(form) {
        if (form.$error.pattern) {
            const propName = form.$error.pattern[0].$name;
            return `hard_tokens.integrate.validation.${this.type}.${this.otpType}.${propName}`;
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-integration/hard-token-importer-table/hard-token-importer-table.controller.js